const swiper_topbar = new Swiper('.swiper-topbar', {
    slidesPerView: 'auto',
    loop: true,
    allowTouchMove: false,
    freeMode: false,
    speed: 8000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    spaceBetween: 264
});

const swiper_blog = new Swiper('.swiper-blog', {
    slidesPerView: 1.3,
    loop: true,
    spaceBetween: 15,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        991: {
            slidesPerView: 2.6
        }
    }
});

const observerOptions = {
    threshold: 0.5,
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-view');
        } else {
            entry.target.classList.remove('animate-view');
        }
    });
}, observerOptions);

document.querySelectorAll('.animate').forEach((element) => {
    observer.observe(element);
});

document.addEventListener('DOMContentLoaded', function() {
    const counters = document.querySelectorAll('.counter');
    
    const animateCounter = (element) => {
        const target = parseInt(element.dataset.target);
        const numberSpan = element.querySelector('.number');
        let current = 0;
        const increment = target / 30;
        
        const interval = setInterval(() => {
            current += increment;
            if (current >= target) {
                numberSpan.textContent = target;
                clearInterval(interval);
            } else {
                numberSpan.textContent = Math.floor(current);
            }
        }, 50);
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });
    
    counters.forEach(counter => observer.observe(counter));
});



// Bind as an event handler

jQuery(function($){
    $(document).on('click', '[data-lightbox]', lity);
    $('#open-mobile-menu').on('click', function(){
        $('#header').toggleClass('header-menu-open');
    });

});

